import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state, keyframes } from '@angular/animations';
import { ProgressbarService } from './progressbar.service';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.css'],
  animations: [trigger('progressbar', [
    state('show', style({width: '90%', opacity: 1})),
    state('hide', style({opacity: 0, width: 0})),
    transition('hide => show', [
      animate('3s', keyframes([
        style({width: '30%', opacity: 1, offset: 0.1}),
        style({width: '50%', opacity: 1, offset: 0.8}),
        style({width: '90%', opacity: 1, offset: 1})
      ]))
    ]),
    transition('show => hide', animate('.25s', style({opacity: 0, width: '100%'})))
  ])]
})
export class ProgressbarComponent implements OnInit {

  public state: string;

  constructor(
    private service: ProgressbarService
  ) { }

  ngOnInit() {
    this.service.state.subscribe(loaderState => this.state = loaderState);
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/progressbar/progressbar.component.ts